export default class DailyMenuOptionOfferOrder {
  private constructor (
    readonly id: string,
    readonly foodItem: any,
    readonly price: string,
    readonly portionsCount: number | null,
    readonly reservedPortionsCount: number,
    public amount: number
  ) {}


  static createFromResponse (responseData: any): DailyMenuOptionOfferOrder | undefined {

    if( !responseData )
      return undefined

    return new DailyMenuOptionOfferOrder(
      responseData.id,
      responseData.foodItem,
      responseData.price,
      responseData.portionsCount,
      responseData.reservedPortionsCount,
      responseData.amount ? responseData.amount : 1
    )
  }
}
